import { render } from "./WelcomePage.vue?vue&type=template&id=7606e790&scoped=true"
import script from "./WelcomePage.vue?vue&type=script&lang=js"
export * from "./WelcomePage.vue?vue&type=script&lang=js"

import "./WelcomePage.vue?vue&type=style&index=0&id=7606e790&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7606e790"]])

export default __exports__